<template>
  <div class="theme-bg">
    <van-nav-bar
      :title="list.name"
    />
    <div class="index-body">
      <van-cell-group title="设备最新数据">
        <van-cell title="安装位置" :value="list.address"/>
        <van-cell title="遥测站地址" :value="list.station_address"/>
        <div v-if="list.device_type !=3">
          <van-cell  title="水位(m)" :value="list.water_level"/>
          <van-cell title="流量(m³/s)" :value="list.water_volume"/>
          <van-cell title="电池电压" :value="list.voltage"/>
        </div>
        <div v-else>
          <van-cell  title="压力(Mpa)" :value="list.pressure"></van-cell>
        </div>
        <van-cell title="时间" :value="list.see_times"/>
      </van-cell-group>
      <van-cell-group title="设备详情" >
        <van-cell title="设备详情" is-link @click="deviceDetails"/>
      </van-cell-group>
      <van-cell-group title="数据查询">
        <van-cell title="设备记录" is-link @click="dataQuery"/>
      </van-cell-group>

    </div>
  </div>
</template>

<script>
  import axios from "axios";
  export default {
    name: "Index",
    data() {
      return {
        list: [],
        station_address_id: this.$Request.station_address,

      };
    },
    created() {
      let station_address = this.$Request.station_address;
      this.getInstrumentData(station_address)
    },
    methods: {
      getInstrumentData(station_address) {
        var that = this
        let dataInfo = {
          station_address: station_address
        };
        axios({
          method: 'post',
          url: 'monitor/report_new_data',
          data: dataInfo
        }).then(function (response) {
          if (response.data.code == 1) {
            that.list = response.data.data

          } else {
            that.list = null
          }
        }).catch(function (error) {
          console.log(error);
        });
      },

      deviceDetails() {
        let station_address = this.$Request.station_address;
        this.$router.push('/DeviceMessagePage?station_address=' + station_address);
      },
      dataQuery() {
        let station_address = this.$Request.station_address;
        if (this.list.device_type==3){
          this.$router.push('/DevicePressurePage?station_address=' + station_address);
        }else {
          this.$router.push('/DeviceDetailsPage?station_address=' + station_address);
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Index.vue